import React, { Component  } from 'react'
import classNames from 'classnames'
import "./SuggestedSearchTerms.css"

const terms = ["Customization", "Authentication", "Restoration"];

function SuggestedSearchField(props) {
  return (
    <li key={props.value} className={classNames("suggest-search-word", { selected: props.selected })} onClick={props.onClick}>
      {props.value}
    </li>
  );
}

class SuggestedSearchTerms extends Component {

    isSelected(name) {
        return (this.props.category === name.toLowerCase()) || ((name.toLowerCase() !== 'authentication' && this.props.category !== 'authentication') && (name.toLowerCase() !== 'restoration' && this.props.category !== 'restoration'));
    }

    renderSearchField(i) {
        return (
        <SuggestedSearchField
            value={i}
            selected={this.isSelected(i)}
            onClick={() => this.props.onClick(i)}
            key={i}
        />
        );
    }

    render() {
        return (
            <div className="search-terms-list">
                <div className="header">CUSTOM SHOP SERVICES:</div>
                <ul>
                    {terms.map(function(t, index) {
                        return this.renderSearchField(t);
                    }, this)}
                </ul>
            </div>
        );
    }
}

export default SuggestedSearchTerms;
